const TimeZones = [
    {
        label: 'New York, NY - EST',
        tz: 'America/New_York',
    },
    {
        label: 'Chicago, IL - CST',
        tz: 'America/Chicago',
    },
    {
        label: 'Denver, CO - MST',
        tz: 'America/Denver',
    },
    {
        label: 'Phoenix, AZ - MST no DST',
        tz: 'America/Phoenix',
    },
    {
        label: 'Los Angeles, CA - PST',
        tz: 'America/Los_Angeles',
    },
    {
        label: 'Anchorage, AK - AKST',
        tz: 'America/Anchorage',
    },
    {
        label: 'Adak, AK - HST',
        tz: 'America/Adak',
    },
    {
        label: 'Honolulu, HI - HST no DST',
        tz: 'Pacific/Honolulu',
    },


];

export default TimeZones;
